import { useEffect } from 'react';
import { clearExperienceCart } from '../utils/cart';

function LogOut() {
	useEffect(() => {
		localStorage.removeItem("token");
		clearExperienceCart();
		window.location.replace("/");
	}, []);

	return null;
}

export default LogOut;
